//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminTransactionController_findOneById,
  Response$AdminTransactionController_findOneById$Status$200,
  ResponseContentType$AdminTransactionController_findOneById,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminTransactionController_findOneById = (options: {
  params: Params$AdminTransactionController_findOneById['parameter'];
  config?: QueryOptions<
    Response$AdminTransactionController_findOneById$Status$200[ResponseContentType$AdminTransactionController_findOneById]
  >;
}) =>
  useApiClient<
    Params$AdminTransactionController_findOneById,
    Response$AdminTransactionController_findOneById$Status$200[ResponseContentType$AdminTransactionController_findOneById]
  >({
    method: 'AdminTransactionController_findOneById',
    params: { parameter: options.params },
    config: options.config,
  });
